@if (loadingBar.running) {
  <p-progressBar mode='indeterminate' [style]="{ height: '5px', position: 'fixed', 'z-index': 100, width: '100%' }">
  </p-progressBar>
}
